import { IconName } from '../enums/icon-enum';

export const ICON_PATH: Record<IconName, string> = {
  [IconName.STAR]: '/assets/icons/log-in-users-display.svg#star',
  [IconName.EMPTY_STAR]: '/assets/icons/log-in-users-display.svg#star-empty',
  [IconName.ARROW_RIGHT_CIRCLE]: '/assets/icons/log-in-users-display.svg#arrow-right-circle',
  [IconName.WARNING_CIRCLE_ICON]: '/assets/icons/log-in-users-display.svg#icon-warning-circle',
  [IconName.RETRY_ARROWS]: '/assets/icons/general-icons.svg#retry-arrows',
  [IconName.SUCCESS_CIRCLE]: '/assets/icons/general-icons.svg#success-circle',
  [IconName.CROSS_CIRCLE]: '/assets/icons/general-icons.svg#cross-circle',
  [IconName.LOG_OUT]: '/assets/icons/general-icons.svg#log-out',
  [IconName.SETTINGS]: '/assets/icons/general-icons.svg#settings',
  [IconName.HELP_CIRCLE]: '/assets/icons/general-icons.svg#icon-help',
  [IconName.MAIN_LOGO]: 'assets/icons/icons.svg#main-logo',
  [IconName.CLOSE]: '/assets/icons/general-icons.svg#icon-close',
  [IconName.CLOCK_EXPIRED]: '/assets/icons/general-icons.svg#icon-clock-expired',
  [IconName.SAD_FACE]: 'assets/icons/icons.svg#sad-face',
  [IconName.LANDING_LOGIN_ARROWHEAD]: 'assets/icons/landing-icons.svg#landing-login-arrowhead',
  [IconName.LANDING_LOGIN_DOOR]: 'assets/icons/landing-icons.svg#landing-login-door',
  [IconName.LANDING_LOGIN_LINE]: 'assets/icons/landing-icons.svg#landing-login-line',
  [IconName.LANDING_LOGOMARK]: 'assets/icons/landing-icons.svg#landing-logomark',
  [IconName.LANDING_OFFLINE_ICON]: 'assets/icons/landing-icons.svg#landing-offline-icon',
  [IconName.LANDING_PLAN_BADGE]: 'assets/icons/landing-icons.svg#landing-plan-badge',
  [IconName.LANDING_PLAN_CHECK]: 'assets/icons/landing-icons.svg#landing-plan-check',
  [IconName.LANDING_PLAN_CROSS_FEATURED]:
    'assets/icons/landing-icons.svg#landing-plan-cross-featured',
  [IconName.LANDING_PLAN_CROSS]: 'assets/icons/landing-icons.svg#landing-plan-cross',
  [IconName.LANDING_SOCIAL_FACEBOOK]: 'assets/icons/landing-icons.svg#landing-social-facebook',
  [IconName.LANDING_SOCIAL_INSTAGRAM]: 'assets/icons/landing-icons.svg#landing-social-instagram',
  [IconName.LANDING_SOCIAL_LINKEDIN]: 'assets/icons/landing-icons.svg#landing-social-linkedin',
  [IconName.LANDING_SOCIAL_X]: 'assets/icons/landing-icons.svg#landing-social-x',
  [IconName.LANDING_SOCIAL_YOUTUBE_MARK]:
    'assets/icons/landing-icons.svg#landing-social-youtube-mark',
  [IconName.LANDING_SOCIAL_YOUTUBE]: 'assets/icons/landing-icons.svg#landing-social-youtube',
  [IconName.LANDING_STEP_ARROW]: 'assets/icons/landing-icons.svg#landing-step-arrow',
};
